import React from 'react';
import '../styles/DevBanner.css';

const DevBanner = () => {
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div className="dev-banner">
      <span className="dev-banner__text">DEV ENVIRONNEMENT</span>
    </div>
  );
};

export default DevBanner;